import { useNavigate, useLocation } from 'react-router-dom';

export type Route = 'landing' | 'medication-addition' | 'checkout-billing' | 'inventory' | 'frontdesk-homepage' | 'frontdesk-dashboard' | 'pharma-homepage' | 'purchase-history' | 'sales-history' | 'distributors-history' | 'purchase-page' | 'billing-page' | 'notifications';

interface NavigationState {
  currentRoute: Route;
  isTransitioning: boolean;
  navigateTo: (route: Route) => void;
  goBack: () => void;
  history: Route[];
}

export const useNavigation = (): NavigationState => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Map pathname to route
  const getCurrentRoute = (): Route => {
    switch (location.pathname) {
      case '/medication-addition':
        return 'medication-addition';
      case '/checkout-billing':
        return 'checkout-billing';
      case '/inventory':
        return 'inventory';
      case '/frontdesk-homepage':
        return 'frontdesk-homepage';
      case '/frontdesk-dashboard':
        return 'frontdesk-dashboard';
          case '/pharma-homepage':
            return 'pharma-homepage';
          case '/purchase-history':
            return 'purchase-history';
          case '/sales-history':
            return 'sales-history';
          case '/distributors-history':
            return 'distributors-history';
          case '/purchase-page':
            return 'purchase-page';
          case '/billing-page':
            return 'billing-page';
          case '/notifications':
            return 'notifications';
          case '/':
          default:
            return 'landing';
    }
  };

  const navigateTo = (route: Route): void => {
    const pathMap: Record<Route, string> = {
      'landing': '/',
      'medication-addition': '/medication-addition',
      'checkout-billing': '/checkout-billing',
      'inventory': '/inventory',
          'frontdesk-homepage': '/frontdesk-homepage',
          'frontdesk-dashboard': '/frontdesk-dashboard',
          'pharma-homepage': '/pharma-homepage',
          'purchase-history': '/purchase-history',
          'sales-history': '/sales-history',
          'distributors-history': '/distributors-history',
          'purchase-page': '/purchase-page',
          'billing-page': '/billing-page',
          'notifications': '/notifications'
        };
    
    navigate(pathMap[route]);
  };

  const goBack = (): void => {
    navigate(-1); // Go back in browser history
  };

  return {
    currentRoute: getCurrentRoute(),
    isTransitioning: false, // React Router handles transitions
    navigateTo,
    goBack,
    history: [] // Browser handles history
  };
};
